
import { defineComponent, PropType } from 'vue'
import { DynamicRiskLevel } from '~/types/types'
import { getDynamicRiskTagInfo } from '~/utils/ui'

export default defineComponent({
  name: 'DynamicRiskIndicator',
  props: {
    dynamicRisk: {
      type: String as PropType<DynamicRiskLevel>,
      required: true
    }
  },
  computed: {
    indicatorInfo() {
      return getDynamicRiskTagInfo(this.dynamicRisk)
    }
  }
})
